//gsap.from(".loader-logo", 
//	{
//		duration: .5,
//		scale: 1,
//		autoAlpha: 0,
//	}
//);

var tl = gsap.timeline();

tl.from(".loader-logo", {delay:1, duration: 2, autoAlpha: 0});
tl.to(".loader-logo", {duration: 1});
tl.to(".loader-logo", {opacity: 0, duration: 1});
tl.from(".loader-langs", {autoAlpha: 0});

// $(document).ready(function () {
// 	$('body').addClass("loader");
// });

var data_lang = sessionStorage.getItem('lang');

$('.btn-lang').click(function (e) {
	e.preventDefault();

	// $('#loader-wrapper').addClass("go");
	// $('body').removeClass("loader");

	var lang = $(this).data('lang');

	jQuery.post(
        ajaxurl,
        {
            'action': 'set_lang',
            'lang': lang,
        },
        function(response){
            // $('#loader-wrapper').addClass("go");
			// $('body').removeClass("loader");
			if (response == "fr") {
				window.location.replace("https://abcosmetique.com");
			} else {
				window.location.replace("https://abcosmetique.com/"+lang+"/");
			}
        }
    );
});